//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpProgressBar',
  props: {
    progress: { type: Number, default: 0 },
    size: { type: String, default: '' },
    animated: { type: Boolean, default: true },
  },
  computed: {
    innerWidth() {
      return `${Math.floor(this.progress)}%`;
    },
  },
};
